export default "__VITE_ASSET__Drfpu69B__"